'use strict';

import '../css/simple.scss';
import {documentReady} from "./Shared/DocumentReady";
import DonationAmountOther from "./DonationAmountOther/DonationAmountOther";

documentReady(() => {
    window.super();
    new DonationAmountOther();
});
